const MATERIALS_COLLECTORS = [
  {
    url: "https://www.vedinimas.lt/basic-125-5x75-kolektorine-deze-su-akustine-izoliacija-500x350x140mm",
    icon: "https://www.vedinimas.lt/images/uploader/ba/1188x1188.g/basic-125-5x75-kolektorine-deze-su-izoliacija-350x200x150-mm-2-1.png?t=392295",
    code: "904000001",
    name: "Kolektorinė dėžė Basic 125-5x75",
    quantity: 1,
    airDuctQuantity: 2,
    gasketQuantity: 20,
    range: [0, 5],
    productGroup: "normal",
    good_id: 47573,
  },
  {
    url: "https://www.vedinimas.lt/basic-160-8x75-kolektorine-deze-su-akustine-izoliacija-400x350x195mm",
    icon: "https://www.vedinimas.lt/images/uploader/ba/588x588.g/basic-160-6x75-kolektorine-deze-su-akustine-izoliacija-300x350x195mm-3.jpg?t=236568",
    code: "904000003",
    name: "Kolektorinė dėžė Basic 160-6x75",
    quantity: 1,
    airDuctQuantity: 2,
    gasketQuantity: 30,
    range: [6, 6],
    productGroup: "normal",
    good_id: 47575,
  },
  {
    url: "https://www.vedinimas.lt/basic-160-10x75-kolektorine-deze-su-akustine-izoliacija-500x350x195mm",
    icon: "https://www.vedinimas.lt/images/uploader/ba/588x588.g/basic-160-8x75-kolektorine-deze-su-akustine-izoliacija-400x350x195mm-3.jpg?t=298265",
    code: "904000004",
    name: "Kolektorinė dėžė Basic 160-8x75",
    quantity: 1,
    airDuctQuantity: 3,
    gasketQuantity: 40,
    range: [7, 8],
    productGroup: "normal",
    good_id: 47576,
  },
  {
    url: "https://www.vedinimas.lt/basic-160-12x75-kolektorine-deze-su-akustine-izoliacija-600x350x195mm",
    icon: "https://www.vedinimas.lt/images/uploader/ba/588x588.g/basic-160-10x75-kolektorine-deze-su-akustine-izoliacija-500x350x195mm-2-1.jpg?t=250349",
    code: "904000005",
    name: "Kolektorinė dėžė Basic 160-10x75",
    quantity: 1,
    airDuctQuantity: 3,
    gasketQuantity: 50,
    range: [9, 10],
    productGroup: "normal",
    good_id: 47577,
  },
  {
    url: "https://www.vedinimas.lt/basic-200-14x75-kolektorine-deze-su-akustine-izoliacija-700x350x235mm",
    icon: "https://www.vedinimas.lt/images/uploader/ba/588x588.g/basic-200-12x75-kolektorine-deze-su-akustine-izoliacija-600x350x230mm-1-1.jpg?t=25363",
    code: "904000007",
    name: "Kolektorinė dėžė Basic 200-12x75",
    quantity: 1,
    airDuctQuantity: 4,
    gasketQuantity: 60,
    range: [11, 12],
    productGroup: "normal",
    good_id: 47579,
  },
  {
    url: "https://www.vedinimas.lt/basic-200-14x75-kolektorine-deze-su-akustine-izoliacija-700x350x235mm-1",
    icon: "https://www.vedinimas.lt/images/uploader/ba/588x588.g/basic-200-14x75-kolektorine-deze-su-akustine-izoliacija-700x350x235mm-2-1.jpg?t=272140",
    code: "904000008",
    name: "Kolektorinė dėžė Basic 200-14x75",
    quantity: 1,
    airDuctQuantity: 5,
    gasketQuantity: 70,
    range: [13, 14],
    productGroup: "normal",
    good_id: 47706,
  },
  // PREMIUM
  {
    url: "https://www.vedinimas.lt/125-5x75-izol-kolektorine-deze-pajungimas-is-galo-125-mm-i-5x75-mm-cinkuota-skarda-500x300x150-mm",
    icon: "https://www.vedinimas.lt/images/uploader/or/1188x1188.g/oro-paskirstymo-zoliuotas-kolektorius-5x75-125-su-srauto-paskirstymo-pertvaromis-1.jpg?t=7363",
    code: "901000001",
    name: "Kolektorinė dėžė Pro 125-5x75",
    quantity: 1,
    airDuctQuantity: 2,
    gasketQuantity: 20,
    range: [0, 5],
    productGroup: "premium",
    good_id: 46788,
  },
  {
    url: "https://www.vedinimas.lt/160-6x75-izol-kolektorine-deze-pajungimas-is-galo-160-mm-i-6x75-mm-cinkuota-skarda-300x300x220-mm",
    icon: "https://www.vedinimas.lt/images/uploader/16/500x500.g/160-6x75-izol-kolektorine-deze-pajungimas-is-galo-160-mm-i-6x75-mm-cinkuota-skarda-300x300x220-mm-2-1.jpg?t=358278",
    code: "901000002",
    name: "Kolektorinė dėžė Pro 160-6x75",
    quantity: 1,
    airDuctQuantity: 2,
    gasketQuantity: 30,
    range: [6, 6],
    productGroup: "premium",
    good_id: 46789,
  },
  {
    url: "https://www.vedinimas.lt/160-8x75-izol-kolektorine-deze-pajungimas-is-galo-160-mm-i-8x75-mm-cinkuota-skarda-400x300x200-mm",
    icon: "https://www.vedinimas.lt/images/uploader/16/500x500.g/160-8x75-izol-kolektorine-deze-pajungimas-is-galo-160-mm-i-8x75-mm-cinkuota-skarda-400x300x200-mm-1-1.jpg?t=748712",
    code: "901000003",
    name: "Kolektorinė dėžė Pro 160-8x75",
    quantity: 1,
    airDuctQuantity: 3,
    gasketQuantity: 40,
    range: [7, 8],
    productGroup: "premium",
    good_id: 46790,
  },
  {
    url: "https://www.vedinimas.lt/160-10x75-izol-kolektorine-deze-pajungimas-is-galo-160-mm-i-10x75-mm-cinkuota-skarda-500x300x220-mm",
    icon: "https://www.vedinimas.lt/images/uploader/16/500x500.g/160-10x75-izol-kolektorine-deze-pajungimas-is-galo-160-mm-i-10x75-mm-cinkuota-skarda-500x300x220-mm-1-1.jpg?t=32678",
    code: "901000004",
    name: "Kolektorinė dėžė Pro 160-10x75",
    quantity: 1,
    airDuctQuantity: 3,
    gasketQuantity: 50,
    range: [9, 10],
    productGroup: "premium",
    good_id: 46791,
  },
  {
    url: "https://www.vedinimas.lt/200-12x75-izol-kolektorine-deze-pajungimas-is-galo-200-mm-i-12x75-mm-cinkuota-skarda-600x300x220-mm",
    icon: "https://www.vedinimas.lt/images/uploader/20/500x500.g/200-12x75-izol-kolektorine-deze-pajungimas-is-galo-200-mm-i-12x75-mm-cinkuota-skarda-600x300x220-mm-1-1.jpg?t=258463",
    code: "901000005",
    name: "Kolektorinė dėžė Pro 200-12x75",
    quantity: 1,
    airDuctQuantity: 4,
    gasketQuantity: 60,
    range: [11, 12],
    productGroup: "premium",
    good_id: 46792,
  },
  {
    url: "https://www.vedinimas.lt/160-12x75-izol-kolektorine-deze-pajungimas-is-galo-160-mm-i-12x75-mm-cinkuota-skarda-600x300x220-mm",
    icon: "https://www.vedinimas.lt/images/uploader/or/493x493.g/oro-paskirstymo-kolektorius-14x75-200-izoliuotas-1.jpg?t=472473",
    code: "901000007",
    name: "Kolektorinė dėžė Pro 200-14x75",
    quantity: 1,
    airDuctQuantity: 5,
    gasketQuantity: 70,
    range: [13, 14],
    productGroup: "premium",
    good_id: 46794,
  }
];

export default MATERIALS_COLLECTORS;
